module.exports = __webpack_public_path__ + "img/012-013.70b5044e.jpg";